import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./style.module.css";

export const MenuItem = ({ item, setExpanded, pageTop, sectionRefs }) => {
  const [anchorTarget, setAnchorTarget] = useState(null);

  useEffect(() => {
    setAnchorTarget(
      item.scrollToSection ? sectionRefs[item.text]?.current : pageTop
    );
  }, [item, pageTop, sectionRefs]);

  const handleClick = () => {
    setExpanded(false);
    setTimeout(() => {
      anchorTarget.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 250);
  };

  return (
    <li className={styles.flexWrapper}>
      {item.isIcon ? (
        <a
          className={styles.iconContainer}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={item.image} className={styles.flexWrapper} alt={item.alt} />
        </a>
      ) : (
        <Link
          to={item.to}
          onClick={handleClick}
          className={styles.navLink}
          aria-label={`Ir a ${item.text}`}
        >
          {item.text}
        </Link>
      )}
    </li>
  );
};
